// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","red":"#EF4058","grey":"#AFB0B0","grey1":"#F3F3F3","grey2":"#D8D8D8","grey3":"#4E4E4E","dark":"#252525","dark1":"#111"};